<template>
  <div class="case-digital-mlpa-main-upload-page col-block width-full">
    <div class="case-digital-mlpa-main-upload-container block col-block width-full">
      <div class="case-digital-mlpa-main-upload-block block col-block width-full">
        <div class="case-digital-mlpa-main-upload-main-container col-block width-full">
          <div class="case-digital-mlpa-main-upload-main-block row-block flex-start">
            <div class="case-digital-mlpa-main-upload-form-container col-block width-full" :style="{ flex: 1 }">
              <div class="case-digital-mlpa-main-upload-form-title-container row-block">
                <div class="case-digital-mlpa-main-upload-form-title">{{ $t('COMPONENT.digitalMLPA.mainUpload.upload.___title') }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-if="file" class="case-digital-mlpa-main-upload-form-file">{{ file.name }}</div>
              <div class="case-digital-mlpa-main-upload-form-input col-block flex-start">
                <div class="center-block">
                  <input v-show="false" type="file" :id="'mlpa-file'" accept="text/xml,application/xml" extension="xml" @change="e => fileTypeCheck(e, e => selectFile(e), () => addToast('error', $t('COMMON.toast.___fileTypeAlert', { types: 'XML' })))">
                  <label :for="'mlpa-file'" class="white-button circle-button center-block">
                    <span>{{ $t('COMMON.button.___select') }}</span>
                  </label>
                </div>
              </div>
              <div v-if="alert" class="case-digital-mlpa-main-upload-form-alert">{{ alert }}</div>
            </div>
            <div class="case-digital-mlpa-main-upload-notification-container col-block width-full" :style="{ flex: 1 }">
              <div class="case-digital-mlpa-main-upload-notification-title-container row-block">
                <div class="case-digital-mlpa-main-upload-notification-title">{{ $t('COMPONENT.digitalMLPA.mainUpload.notification.___title', { version: 'v2.5.1' }) }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div
                class="case-digital-mlpa-main-upload-notification-content"
                v-html="$t('COMPONENT.digitalMLPA.mainUpload.notification.___content')"
              ></div>
            </div>
          </div>
        </div>
        <div :style="{ height: '30px' }"></div>
        <div class="case-digital-mlpa-main-upload-button-container row-block">
          <div :style="{ flex: 1 }"></div>
          <button class="main-button circle-button" :disabled="!file" @click="e => $emit('create', sendData)">
            <span>{{ $t('COMMON.button.___analysis') }}</span>
          </button>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import toastMethods from '../../mixins/toastMethods.vue'
import { fileTypeCheck } from '../../constants/global/util'

export default {
  mixins: [
    toastMethods
  ],
  data () {
    return {
      file: null,
      alert: ''
    }
  },
  computed: {
    sendData () {
      return { file: this.file }
    },
    // global
    fileTypeCheck () { return fileTypeCheck }
  },
  methods: {
    async selectFile (e) {
      let file = e.target.files[0]
      let alert = await this.checkFile()
      if (alert) {
        this.alert = alert
      } else {
        this.file = file
        this.alert = ''
        e.target.value = ''
      }
    },
    async checkFile (file) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/digitalMLPA/mainUpload.vue